import React from 'react';
import { connect } from 'react-redux';

import {
  selectIsAuthenticated,
  selectIsUserAdvanced,
  selectIsUserProfessional,
  selectUuid,
} from '../../redux/auth/user/selectors';

import CheckoutButtonAdvanced from './CheckoutButtonAdvanced';

const CheckoutButtonAdvancedConnected = (props) => <CheckoutButtonAdvanced {...props} />;

const mapStateToProps = (state) => ({
  isAuthenticated: selectIsAuthenticated(state),
  isUserAdvanced: selectIsUserAdvanced(state),
  isUserProfessional: selectIsUserProfessional(state),
  uuid: selectUuid(state),
});

export default connect(mapStateToProps)(CheckoutButtonAdvancedConnected);
